"use client"

import { useState, forwardRef, useImperativeHandle } from "react"
import styles from "./styles.module.css"
import { FaRegEdit } from "react-icons/fa"
import Button from "../../../modules/Button/Button"

const EmailPreview = forwardRef(({ devices }, ref) => {
  const initialEmail = () => {
    const orderLines = devices
      .map((device, index) => `${index + 1}: We need ${device.quantity} ${device.name} Devices`)
      .join("\n")

    return {
      subject: "Bulk Device Order Requirement",
      to: "khadijanawaz8302@gmail.com",
      body: `Dear fjames,
  I would like to place a bulk order for the following:
  
${orderLines}
 
  Please arrange delivery at your earliest convenience. Kindly confirm the order and provide any further details needed to proceed.
  Thank you for your support.
  Best regards,
  TOCA`,
    }
  }

  const [isEditing, setIsEditing] = useState(false)
  const [email, setEmail] = useState(initialEmail)
  const [draft, setDraft] = useState(initialEmail)

  useImperativeHandle(ref, () => ({
    getEmailData: () => email,
  }))

  const handleInput = (e, key) => {
    setDraft((prev) => ({ ...prev, [key]: e.target.value }))
  }

  const handleEdit = () => {
    setDraft(email)
    setIsEditing(true)
  }

  const handleSave = () => {
    setEmail(draft)
    setIsEditing(false)
  }

  const handleCancel = () => {
    setDraft(email)
    setIsEditing(false)
  }

  const renderBody = (body) => {
    const lines = body.split(/\n+/)
    return (
      <div style={{ whiteSpace: "pre-wrap" }}>
        {lines.map((line, idx) => {
          if (/^\d+: We need/.test(line.trim())) {
            // Make order lines bold
            return (
              <div key={idx} style={{ marginBottom: 8, fontWeight: 700 }}>
                {line}
              </div>
            )
          }
          if (line.trim().startsWith("• ")) {
            return (
              <div key={idx} style={{ marginLeft: 20, fontWeight: 600, marginBottom: 8 }}>
                <span style={{ fontSize: 18, marginRight: 8 }}>•</span>
                {line.replace(/^• /, "")}
              </div>
            )
          }
          // Normal lines
          return (
            <div key={idx} style={{ marginBottom: 8 }}>
              {line}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <section className={styles.container}>
      <header className={styles.containerHeader}>
        <p>Email</p>
        {!isEditing && <FaRegEdit size={20} onClick={handleEdit} style={{ cursor: "pointer" }} />}
      </header>

      <main className={styles.contentContainer}>
        {isEditing ? (
          <>
            <section className={styles.inputField}>
              <h5>Subject</h5>
              <input
                type="text"
                value={draft.subject}
                onChange={(e) => handleInput(e, "subject")}
                className={styles.editableText}
              />
            </section>

            <section className={styles.inputField}>
              <h5>To</h5>
              <input
                type="text"
                value={draft.to}
                onChange={(e) => handleInput(e, "to")}
                className={styles.editableText}
              />
            </section>

            <section>
              <div className={styles.bodyEditContainer}>
                <textarea
                  value={draft.body}
                  onChange={(e) => setDraft((d) => ({ ...d, body: e.target.value }))}
                  className={styles.editableText}
                  style={{
                    width: "100%",
                    minHeight: 200,
                    resize: "vertical",
                    fontSize: 14,
                    fontFamily: "inherit",
                    fontWeight: 400,
                  }}
                />
              </div>
            </section>

            <div className={styles.editorActions}>
              <Button  size="small" variant="secondary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button size="small" onClick={handleSave}>Save</Button>
            </div>
          </>
        ) : (
          <>
            <section className={styles.inputField}>
              <h5>Subject</h5>
              <div>{email.subject}</div>
            </section>

            <section className={styles.inputField}>
              <h5>To</h5>
              <div>{email.to}</div>
            </section>

            <section>
              <div
                style={{
                  background: "#fff",
                  borderRadius: 8,
                  padding: 10,
                  minHeight: 200,
                }}
              >
                <textarea
                  value={email.body}
                  readOnly
                  className={styles.editableText}
                  style={{
                    width: "100%",
                    minHeight: 200,
                    resize: "none",
                    fontSize: 14,
                    fontFamily: "inherit",
                    fontWeight: 400,
                    background: "transparent",
                    border: "none",
                  }}
                />
              </div>
            </section>
          </>
        )}
      </main>
    </section>
  )
})

EmailPreview.displayName = "EmailPreview"

export default EmailPreview
